"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 56.2 24",
    width: "56.2",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m55.37 15.2h-54.54a.78.78 0 1 0 0 1.56h3.82a3.91 3.91 0 1 0 4.06 0h3.86a3.91 3.91 0 1 0 5.94 3.33 3.26 3.26 0 0 0 -.05-.45.83.83 0 0 0 .53.2h17.7a.75.75 0 0 0 .36-.1v.35a3.91 3.91 0 1 0 5.95-3.33h3.86a3.91 3.91 0 1 0 4.06 0h4.49a.78.78 0 1 0 0-1.56zm-48.69 2.53a2.36 2.36 0 1 1 -2.35 2.36 2.36 2.36 0 0 1 2.35-2.36zm10.32 2.36a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36zm-.32-3.33h1.53v1.74a3.86 3.86 0 0 0 -1.58-1.74zm20.88 0h1.34a4 4 0 0 0 -1.39 1.47zm3.42 1a2.36 2.36 0 1 1 -2.35 2.36 2.36 2.36 0 0 1 2.3-2.39zm10.22 2.33a2.36 2.36 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z"
  }));
};

exports["default"] = _default;